import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Switch, message } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';
import useDocumentStore from '../stores/documentStore';
import './DocumentAccessControl.css';

function DocumentAccessControl({ documentId }) {
  const { t } = useTranslation();
  const {
    isPublic, 
    publicUrl, 
    isPublicLoading,
    enablePublicAccess,
    disablePublicAccess
  } = useDocumentStore();

  const handlePublicToggle = async (checked) => {
    try {
      if (checked) {
        await enablePublicAccess(documentId);
        message.success(t('accessControl.enabled'));
      } else {
        await disablePublicAccess(documentId);
        message.success(t('accessControl.disabled'));
      }
    } catch (error) {
      message.error(t('accessControl.error'));
    }
  };

  return (
    <div className="document-access-control">
      <div className="document-access-control__access-controls">
        <span className="document-access-control__title">{t('accessControl.title')}</span>
        <Switch
          checked={isPublic}
          onChange={handlePublicToggle}
          loading={isPublicLoading}
        />
      </div>
    </div>
  );
}

export default DocumentAccessControl; 
